import { render, staticRenderFns } from "./FormGetPromotion.vue?vue&type=template&id=013d01fb&scoped=true&"
import script from "./FormGetPromotion.vue?vue&type=script&lang=js&"
export * from "./FormGetPromotion.vue?vue&type=script&lang=js&"
import style0 from "./FormGetPromotion.vue?vue&type=style&index=0&id=013d01fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d01fb",
  null
  
)

export default component.exports